import { getSharedStrings } from '../xml/xlsx.js';
export default function parseSharedStrings(content, xml) {
  if (!content) {
    return [];
  }

  return getSharedStrings(xml.createDocument(content));
}
//# sourceMappingURL=parseSharedStrings.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/modules/read/parseSharedStrings.js
// module id = 1539
// module chunks = 0